/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('data.security-provider', []);
